import { MdDone } from 'react-icons/md';
import { PiHourglass } from 'react-icons/pi';
import { TbProgress } from 'react-icons/tb';

export const actionsStatus = {
  pending: { title: 'A traiter', icon: PiHourglass, color: '#DD0615' },
  ongoing: { title: 'En cours', icon: TbProgress, color: '#F49D1D' },
  completed: { title: 'Fait', icon: MdDone, color: '#7BDFC8' },
};
export const actionsUrgencyComplexity = {
  low: 'Basse',
  medium: 'Moyenne',
  high: 'Élevé',
};

//
// Selects Options mapper
//

export const urgencyComplexity = [
  {
    value: 'low',
    label: 'Basse',
  },
  {
    value: 'medium',
    label: 'Moyenne',
  },
  {
    value: 'high',
    label: 'Élevé',
  },
];
export const status = [
  {
    value: 'pending',
    label: 'A traiter',
  },
  {
    value: 'ongoing',
    label: 'En cours',
  },
  {
    value: 'completed',
    label: 'Fait',
  },
];
export const category = [
  {
    value: 'Marketing',
    label: 'Marketing',
  },
  {
    value: 'RH',
    label: 'RH',
  },
  {
    value: 'Tech',
    label: 'Tech',
  },
  {
    value: 'Audit',
    label: 'Audit',
  },
];
